// extracted by mini-css-extract-plugin
export default {"EnemiesList":"EnemiesList_EnemiesList__8Z48c"};